import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { Meta } from '@mysvg/utils';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-table-footer-meta',
	styleUrls: ['./table-footer-meta.component.scss'],
	templateUrl: './table-footer-meta.component.html',
	standalone: false,
})
export class TableFooterMetaComponent implements OnChanges {
	@Input() meta: Meta;

	/**
	 * Optional flag to mark when currency sums in meta properties are input as cents (values need to /100)
	 */
	@Input() euroInCents = false;

	isValid: boolean;

	ngOnChanges(): void {
		this.isValid = this.meta && Object.keys(this.meta).length > 0;
	}
}
